import { CreditScore } from './CreditScoreInterface';

export const getScoreByPriority = (scores: CreditScore[]): number => {
  const priorities = ['ERS Value', 'FICO Value', 'Score Complete Value'];

  for (const priority of priorities) {
    const scoreObject = scores?.find((score) => score.name === priority);
    if (scoreObject && scoreObject?.score > 0) {
      return scoreObject?.score;
    }
  }

  return 0;
};
